import { TranslateService } from '@ngx-translate/core';
import { Component, ElementRef, HostListener, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

/** Web counterpart of mobile SettingsActionBar's save action. Navigation belongs to the caller. */
@Component({
  selector: 'button[appSaveAction]',
  standalone: false,
  template: `
    <span class="app-save-label" [class.app-save-label--hidden]="showSaved"><ng-content></ng-content></span>
    @if (showSaved) {
      <span class="app-save-feedback" aria-hidden="true"><i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>{{ 'common.saved' | translate }}</span>
    }
    <span class="sr-only" role="status" aria-live="polite">{{ showSaved ? ('common.saved' | translate) : '' }}</span>
  `,
  host: {
    'class': 'app-action-button app-save-action',
    '[class.app-save-action--saved]': 'showSaved',
    '[attr.aria-busy]': 'saving',
    '[attr.aria-label]': 'showSaved ? savedLabel : null',
    '[disabled]': 'disabled || saving || showSaved',
  },
})
export class SaveActionComponent implements OnChanges, OnDestroy {
  @Input() disabled = false;
  @Input() saved = false;
  @Input() saving = false;
  showSaved = false;
  private timer: ReturnType<typeof setTimeout>;

  constructor(private element: ElementRef<HTMLButtonElement>, private translate: TranslateService) {}

  get savedLabel(): string { return this.translate.instant('common.saved'); }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.saved && !changes.saving) return;
    this.clearFeedback();
    if (this.saved && !this.saving) {
      this.showSaved = true;
      this.timer = setTimeout(() => this.clearFeedback(), 1800);
    }
  }

  @HostListener('document:input')
  @HostListener('document:change')
  clearFeedback(): void {
    clearTimeout(this.timer);
    this.showSaved = false;
  }

  @HostListener('document:click', ['$event'])
  onInteraction(event: MouseEvent): void {
    if (!this.element.nativeElement.contains(event.target as Node)) this.clearFeedback();
  }

  ngOnDestroy(): void { this.clearFeedback(); }
}
